import React from 'react';
import { classNames } from 'utils/styleUtils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // Extends all standard HTML input attributes
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={classNames(
        'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900',
        'outline outline-1 -outline-offset-1 outline-gray-300',
        'placeholder:text-gray-400',
        'focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-dataops-primary-blue',
        'disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed',
        'sm:text-sm/6',
        className,
      )}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
